<template>
  <b-card
    no-body
  >
    <b-row class="d-flex align-items-center mb-1">
      <b-col md="4">
        <h5>{{ slicesType == 'distance' ? 'Distance' : slicesType == 'waiting' ? 'Waiting Time' : 'Time' }} Slices</h5>
      </b-col>
      <b-col md="4">
        <b-button
          size="sm"
          variant="success"
          @click="addNewSlice"
        >
          <feather-icon icon="PlusIcon" />
        </b-button>

      </b-col>
      <!-- <b-col md="4">
        <b-button
          size="sm"
          variant="primary"
          @click="saveSlicings"
        >
          Save
        </b-button>
      </b-col> -->
    </b-row>
    <validation-observer ref="slicingsRef">
      <b-row
        v-for="(slice, index) in slices"
        :key="slice._id"
      >
        <b-col md="3">
          <validation-provider
            name="From Time"
            rules="required"
          >
            <b-form-group
              slot-scope="{ errors }"
              :label="`From ${slicesType == 'distance' ? '(KM)': slicesType == 'waiting' ? '(Minutes)' : '(Minutes)'}`"
              :label-for="`slicing-from-${componentId}-${index}`"
            >
              <b-form-input
                :id="`slicing-from-${componentId}-${index}`"
                v-model.number="slice.from_unit"
                type="number"
                @blur="emitSlices"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="3">
          <validation-provider
            name="To Time"
            rules="required"
          >
            <b-form-group
              slot-scope="{ errors }"
              :label="`To ${slicesType == 'distance' ? '(KM)': slicesType == 'waiting' ? '(Minutes)' : '(Minutes)'}`"
              :label-for="`slicing-to-${componentId}-${index}`"
            >
              <b-form-input
                :id="`slicing-to-${componentId}-${index}`"
                v-model.number="slice.to_unit"
                type="number"
                @blur="emitSlices"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="3">
          <validation-provider
            name="Amount"
            rules="required"
          >
            <b-form-group
              slot-scope="{ errors }"
              label="Amount"
              :label-for="`slicing-amount-${componentId}-${index}`"
            >
              <b-form-input
                :id="`slicing-amount-${componentId}-${index}`"
                v-model.number="slice.amount"
                type="number"
                :state="getAmountState(slice.amount, errors)"
                @blur="emitSlices"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col
          md="3"
          class="d-flex align-items-center"
        >
          <b-form-group
            v-if="!hideFixedSlice"
            label="Fixed Slice"
            :label-for="`slicing-fixed-${componentId}-${index}`"
          >
            <b-form-checkbox
              :id="`slicing-fixed-${componentId}-${index}`"
              v-model="slice.is_fixed_slice"
              @change="emitSlices"
            />

          </b-form-group>
          <b-button
            variant="flat-danger"
            @click="deleteSlicing(index)"
          >
            <feather-icon icon="TrashIcon" />
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BFormGroup, BFormInput, BRow, BCol, BButton, BCard, BFormCheckbox,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    BCard,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BRow,
    BCol,
    BButton,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    slicesType: {
      type: String,
      default: 'time',
    },
    slicings: {
      type: Array,
      default: () => [],
    },
    hideFixedSlice: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const userData = JSON.parse(localStorage.getItem('userData'))
    const userCountry = userData?.country || 'JO'

    // Generate a unique component instance ID
    const componentId = `${props.slicesType}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`

    // Add unique IDs to existing slices for stable keys
    const slicesWithIds = props.slicings 
      ? JSON.parse(JSON.stringify(props.slicings)).map((slice, idx) => ({
          ...slice,
          _id: slice._id || `${componentId}-slice-${idx}`,
        }))
      : []
    
    const slices = ref(slicesWithIds)
    
    const addNewSlice = () => {
      const temp = {
        from_unit: null,
        to_unit: null,
        amount: null,
        _id: `${componentId}-slice-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      }
      if (!props.hideFixedSlice) {
        temp.is_fixed_slice = false
      }
      slices.value.push(temp)
    }

    const deleteSlicing = index => {
      slices.value.splice(index, 1)
      emitSlices()
    }
    const slicingsRef = ref(null)

    const emitSlices = async () => {
      const valid = await slicingsRef.value.validate()
      if (valid) {
        // Remove internal _id field before emitting
        const cleanSlices = slices.value.map(slice => {
          const { _id, ...rest } = slice
          return rest
        })
        emit(`${props.slicesType}-slices`, JSON.parse(JSON.stringify(cleanSlices)))
      }
    }

    const getAmountState = (amount, errors) => {
      // If there are validation errors, return false (invalid state)
      if (errors && errors.length) {
        return false
      }
      
      // If the field is empty (null, undefined, or empty string), return null (neutral state)
      if (amount === null || amount === undefined || amount === '') {
        return null
      }
      
      // Apply the same condition as before: (userCountry == 'JO' ? !(slice.amount >= 1) : true)
      if (userCountry === 'JO') {
        return !(amount >= 1)
      }
      
      // For other countries, any non-empty value is valid
      return true
    }

    return {
      slices,
      addNewSlice,
      deleteSlicing,
      slicingsRef,
      emitSlices,
      getAmountState,
      required,
      userCountry,
      componentId,
    }
  },
}
</script>
